import { Injectable } from "@angular/core";

const STATS_MONITORING_INTERVAL = 15000; //5 seconds
// Servizio per gestire il monitoring delle statistiche delle sessioni WebRTC
@Injectable({
  providedIn: 'root'
})
export class StatsMonitoringService {
  private statsIntervals = new Map<string, number>();
  
  startMonitoring(session: any) {
    const sessionId = session.id;
    
    if (this.statsIntervals.has(sessionId)) {
      return; // Già in monitoring
    }
    
    const pc = session.sessionDescriptionHandler.peerConnection;
    
    const intervalId = window.setInterval(() => {
      pc.getStats().then((stats: RTCStatsReport) => {
        stats.forEach((report: RTCStats) => {
          if (report.type === 'outbound-rtp' && (report as any).mediaType === 'video') {
            const videoReport = report as any;
            console.log(`StatsMonitoring - Session ${sessionId} - Video OUT:`, {
              bitrate: Math.round(videoReport.bytesSent * 8 / (videoReport.timestamp / 1000)),
              fps: videoReport.framesPerSecond,
              resolution: `${videoReport.frameWidth}x${videoReport.frameHeight}`,
              packetsLost: videoReport.packetsLost
            });
          }
        });
      });
    }, STATS_MONITORING_INTERVAL);
    
    this.statsIntervals.set(sessionId, intervalId);
  }
  
  stopMonitoring(sessionId: string) {
    const intervalId = this.statsIntervals.get(sessionId);
    if (intervalId) {
      clearInterval(intervalId);
      this.statsIntervals.delete(sessionId);
    }
  }
  
  stopAllMonitoring() {
    this.statsIntervals.forEach(intervalId => clearInterval(intervalId));
    this.statsIntervals.clear();
  }
}